
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import Button from "../../components/ui/Button";
import { useAuth } from "../../context/AuthContext";
import { Eye, EyeOff } from "lucide-react";

import Heading from "../../components/ui/Heading"; 
import SearchInput from "../../components/ui/SearchInput";
function ChangePassword() {
  const { user } = useAuth(); // user contains UsrName from login
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Load users from API
  useEffect(() => {
    if (user?.UsrName) {
      api
        .getMobileUser(user.UsrName)
        .then((res) => {
          if (res?.Table) setUsers(res.Table);
        })
        .catch((err) => console.error("Error fetching users:", err));
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedUserId || !newPassword) {
      alert("Please select user and enter new password");
      return;
    }

    try {
      const payload = {
        UsrId: selectedUserId,
        Password: newPassword,
      };

      const res = await api.post("UpdateMobUserPasswordAPI", payload);
      const data = res?.data || res; // handle axios vs fetch

      console.log("API Response:", data);

      // Treat any 200 response as success since API returns {}
      alert("Password updated successfully!");
      window.location.href = "/dashboard"; // redirect to dashboard
    } catch (error) {
      console.error("Error updating password:", error);
      alert("Error updating password. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white shadow-lg rounded-2xl p-6">
    
 <Heading>Change Password</Heading>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* User Dropdown */}
        <div>
          <label className="block mb-1 text-sm font-medium">Select User</label>
          <select
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
          >
            <option value="">-- Select User --</option>
            {users.map((u) => (
              <option key={u.UsrId} value={u.UsrId}>
                {u.UsrName}
              </option>
            ))}
          </select>
        </div>

        {/* New Password with eye toggle */}
        <div>
          <label className="block mb-1 text-sm font-medium">New Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              className="w-full border rounded-lg px-3 py-2 pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Submit */}
        <Button type="submit" className="w-full">
          Change Password
        </Button>
      </form>
    </div>
  );
}

export default ChangePassword;
